import React, { PropTypes, Component } from 'react'
import constants from 'constants'
import { Progress } from '.'
// import moment from 'moment'
import { format } from 'date-fns'

class FinalAssessmentAgreed extends Component {
  static propTypes = {
    handleFinalCounsellorAssessmentNotes: PropTypes.func.isRequired,
    // handleFinalSelfAssessmentNotes: PropTypes.func.isRequired,
    handleInterimCounsellorAssessmentNotes: PropTypes.func.isRequired,
    // handleInterimSelfAssessmentNotes: PropTypes.func.isRequired,
    partnerPlan: PropTypes.object.isRequired,
    selectedPlan: PropTypes.object.isRequired,
  }

  render() {
    const {
      partnerPlan,
      selectedPlan,
      // handleInterimSelfAssessmentNotes,
      handleInterimCounsellorAssessmentNotes,
      // handleFinalSelfAssessmentNotes,
      handleFinalCounsellorAssessmentNotes,
    } = this.props

    const steps = [
      {
        key: 1,
        label: constants.PARTNERPLAN.STEPS.UPLOAD,
        desc: `${constants.PARTNERPLAN.STATUS.UPLOADED}: ${(partnerPlan.partnerPlan.planUploadedDate ?
          format(new Date(partnerPlan.partnerPlan.planUploadedDate), constants.DATE_FORMAT.PARTNER_PLAN_FORM) : '')}`,
        isDone: true,
        isCurrent: false,
        actions: [],
      },
      {
        key: 2,
        label: constants.PARTNERPLAN.STEPS.SUBMIT,
        desc: `${constants.PARTNERPLAN.STATUS.SUBMITTED}: ${(partnerPlan.partnerPlan.planSubmittedDate ?
          format(new Date(partnerPlan.partnerPlan.planSubmittedDate), constants.DATE_FORMAT.PARTNER_PLAN_FORM) : '')}`,
        isDone: true,
        isCurrent: false,
        actions: [],
      },
      {
        key: 3,
        label: constants.PARTNERPLAN.STEPS.AGREED,
        desc: `${constants.PARTNERPLAN.PROGRESS_LABEL.COACH_AGREED}: ${(partnerPlan.partnerPlan.planAgreedDate ?
          format(new Date(partnerPlan.partnerPlan.planAgreedDate), constants.DATE_FORMAT.PARTNER_PLAN_FORM) : '')}`,
        isDone: true,
        isCurrent: false,
        actions: [],
      },
      {
        key: 4,
        label: constants.PARTNERPLAN.STEPS.INTERIM_ASSESSMENT,
        desc: '',
        isDone: true,
        isCurrent: false,
        actions: [],
      },
      {
        key: 5,
        label: constants.PARTNERPLAN.STEPS.INTERIM_ASSESSMENT_SUBMITTED,
        desc: `${partnerPlan.partnerPlan.interimCounsellee ? `"${partnerPlan.partnerPlan.interimCounsellee}" ${constants.PARTNERPLAN.PROGRESS_LABEL.PARTNER_RATING_SUBMITTED}:   
          ${(partnerPlan.partnerPlan.interimDate ? format(new Date(partnerPlan.partnerPlan.interimDate), constants.DATE_FORMAT.PARTNER_PLAN_FORM) : '')}` : ''}`,
        isDone: true,
        isCurrent: false,
        actions: [],
      },
      {
        key: 6,
        label: constants.PARTNERPLAN.STEPS.INTERIM_ASSESSMENT_AGREED,
        desc: `${(selectedPlan.Role === constants.PARTNERPLAN.ROLE.CP && partnerPlan.partnerPlan.interimCounsellor) ? `"${partnerPlan.partnerPlan.interimCounsellor}"` : ''} ${(selectedPlan.Role === constants.PARTNERPLAN.ROLE.CP ? `${constants.PARTNERPLAN.PROGRESS_LABEL.COACH_RATING_AGREED}` : `${constants.PARTNERPLAN.PROGRESS_LABEL.COACH_AGREED}`)}:         
        ${(partnerPlan.partnerPlan.interimAgreedDate ? format(new Date(partnerPlan.partnerPlan.interimAgreedDate), constants.DATE_FORMAT.PARTNER_PLAN_FORM) : '')}`,
        desc2: `${(partnerPlan.partnerPlan.interimRatingVisibility === true && partnerPlan.partnerPlan.finalAgreedInterimRating) ? `"${partnerPlan.partnerPlan.finalAgreedInterimRating}" ${constants.PARTNERPLAN.PROGRESS_LABEL.FINAL_AGREED_INTERIM_RATING}:
          ${(partnerPlan.partnerPlan.finalAgreedInterimRatingSaved ? format(new Date(partnerPlan.partnerPlan.finalAgreedInterimRatingSaved), constants.DATE_FORMAT.PARTNER_PLAN_FORM) : '')}` : ''}`,
        isDone: true,
        isCurrent: false,
        highlight: true,
        actions: [
          {
            label: 'VIEW NOTES',
            onClick: handleInterimCounsellorAssessmentNotes,
            active: true,
            show: (selectedPlan.Role === constants.PARTNERPLAN.ROLE.CP),
          },
        ],
      },
      {
        key: 7,
        label: constants.PARTNERPLAN.STEPS.FINAL_ASSESSMENT,
        desc: '',
        isDone: true,
        isCurrent: false,
        actions: [],
      },
      {
        key: 8,
        label: constants.PARTNERPLAN.STEPS.FINAL_ASSESSMENT_SUBMITTED,
        desc: `${partnerPlan.partnerPlan.finalCounselleeAssessment ? `"${partnerPlan.partnerPlan.finalCounselleeAssessment}" ${constants.PARTNERPLAN.PROGRESS_LABEL.PARTNER_RATING_SUBMITTED}:   
          ${(partnerPlan.partnerPlan.finalDate ? format(new Date(partnerPlan.partnerPlan.finalDate), constants.DATE_FORMAT.PARTNER_PLAN_FORM) : '')}` : ''}`,
        isDone: true,
        isCurrent: false,
        actions: [],        
      },
      {
        key: 9,
        label: constants.PARTNERPLAN.STEPS.FINAL_ASSESSMENT_AGREED,
        desc: `${(selectedPlan.Role === constants.PARTNERPLAN.ROLE.CP && partnerPlan.partnerPlan.finalCounsellorAssessment) ? `"${partnerPlan.partnerPlan.finalCounsellorAssessment}"` : ''} ${(selectedPlan.Role === constants.PARTNERPLAN.ROLE.CP ? `${constants.PARTNERPLAN.PROGRESS_LABEL.COACH_RATING_AGREED}` : `${constants.PARTNERPLAN.PROGRESS_LABEL.COACH_AGREED}`)}:         
        ${(partnerPlan.partnerPlan.finalAgreedDate ? format(new Date(partnerPlan.partnerPlan.finalAgreedDate), constants.DATE_FORMAT.PARTNER_PLAN_FORM) : '')}`,
        desc2: `${(partnerPlan.partnerPlan.finalRatingVisibility === true && partnerPlan.partnerPlan.finalAgreedFinalRating) ? `"${partnerPlan.partnerPlan.finalAgreedFinalRating}" ${constants.PARTNERPLAN.PROGRESS_LABEL.FINAL_AGREED_RATING}: 
          ${(partnerPlan.partnerPlan.finalAgreedFinalRatingSaved ? format(new Date(partnerPlan.partnerPlan.finalAgreedFinalRatingSaved), constants.DATE_FORMAT.PARTNER_PLAN_FORM) : '')}` : ''}`,
        isDone: true,
        isCurrent: false,
        highlight: true,
        actions: [
          {
            label: 'VIEW NOTES',
            onClick: handleFinalCounsellorAssessmentNotes,
            active: true,
            show: (selectedPlan.Role === constants.PARTNERPLAN.ROLE.CP),
          },
        ],        
      },
    ]

    return (
      <Progress steps={steps} />
    )
  }
}

export default FinalAssessmentAgreed



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/components/Progress/FinalAssessmentAgreed.js